// @ts-nocheck
import React, { useEffect, useReducer, useRef  } from "react";
import { ReportsAdd, ReportsRemove } from './reports.body.left.js';
import { ReportsSuggestions } from '../reports/reports.requests.js';

// Interface for technology item
interface TechnologyItem {
	value: string;
	title: string;
	icon?: string;
}

// Interface for selected item
interface SelectedItem {
	query: string;
	item: Partial<TechnologyItem>;
}

// Interface for template
interface Template {
	title: string;
	value: string;
	icon?: string;
}

// Interface for component state
interface TechnologySelectorState {
	suggested: {
		search: TechnologyItem[];
		version: TechnologyItem[];
	};
	selected: {
		search: SelectedItem;
		version: SelectedItem;
	};
	list: wts_ignore_any[];
}

// Interface for component props
interface TechnologySelectorProps {
	template?: Template;
	vtemplate?: Template;
	iteration?: number;
	list?: wts_ignore_any[];
	query?: string;
	version?: boolean;
	icon?: boolean | string;
	onChange?: (list: wts_ignore_any[]) => void;
}

const TechnologySelectorReducer = function( state: TechnologySelectorState, [ type, data ]: [string, wts_ignore_any] ): TechnologySelectorState {

	if( type === "suggested" ){

		if( !state.suggested[ data.type ] )
			return;

		const suggested = data.list || [];

		return {
			...state,
			selected: {
				...state.selected,
				[data.type]: {
					query: data.query === undefined ?
						state.selected[ data.type ].query : (data.query || ""),
					item: {}
				}
			},
			suggested: { ...state.suggested, [ data.type ]: suggested }
		};
	}else if( type === "list" ){
		return {
			...state,
			list: [ ...data ]
		};
	}else if( type === "query" ){
		return {
			...state,
			selected: {
				...state.selected,
				[data.type]: {
					...state.selected[data.type],
					query: data.query || ""
				}
			}
		};
	}else if( type === "selected" ){
		return {
			...state,
			selected: {
				...state.selected,
				[data.type]: {
					query: data.query === undefined ?
						state.selected[ data.type ].query : (data.query || ""),
					item: { ...data.item } || {}
				}
			},
			suggested: {
				search: [],
				version: []
			}
		};
	}else if( type === "remove" ){
		return {
			...state,
			list: ReportsRemove( state, data )
		};
	}else if( type === "add" ){
		return {
			...state,
			list: ReportsAdd( state, data )
		};
	};

	return state;
};

export const TechnologySelector = ( props: TechnologySelectorProps ) => {

	const [ state, dispatch ] = useReducer( TechnologySelectorReducer, {
		suggested: {
			search: [],
			version: []
		},
		selected: {
			search: {
				query: "",
				item: {}
			},
			version: {
				query: "",
				item: {}
			}
		},
		list: []
	});
	const { template, vtemplate } = props;

	useEffect(() => {
		dispatch([ "list",  props.list || [] ]);
	}, [ props.iteration ]);

	useEffect(() => {

		if( !props.onChange )
			return;

		props.onChange( state.list );

	}, [ state.list ]);

	const typeInput = useRef<HTMLSelectElement>( null );
	const valueInput = useRef<HTMLDivElement>( null );
	const versionInput = useRef<HTMLInputElement>( null );
	const timeout = useRef<NodeJS.Timeout | number>( 0 );

	const select = ( event: React.MouseEvent, type: string, item: TechnologyItem ) => {

		dispatch([ "selected", {
			query: item.value,
			type: type,
			item: { ...item }
		} ]);

	};
	const suggest = ( event: React.ChangeEvent<HTMLInputElement>, type: string ) => {

		const value = event.target.value;

		dispatch([ "suggested", { list: [], type: type, query: value } ]);

		if( type === "search" )
			dispatch([ "suggested", { list: [], type: "version", query: "" } ]);

		if( value < 2 && type !== "version" )
			return;

		let query = props.query || "technology";
		let temp: Template | undefined = undefined;

		if( type === "search" ){
			query += "?search=" + value;
			temp = template;
		}else if( type === "version" && state.selected[ "search" ].query ){
			query += "/" + state.selected[ "search" ].query + "/version";
			temp = vtemplate;
		}else
			return;

		clearTimeout( timeout.current );
		timeout.current = setTimeout(() => {

			ReportsSuggestions({
				query: query,
				type: type,
				template: temp
			}, dispatch );

		}, 100 );

	};


	return(
		<div className={"tech"} >
			<div className={"tech-items"}>
				<select className={"tech-type"} name="select" ref={ typeInput }>
					<option className={"tech-type-true"} value={"include"}>include</option>
					<option className={"tech-type-false"} value={"exclude"}>exclude</option>
				</select>

				<div className={"tech-units"} ref={ valueInput }>
					<input
						className={"tech-units-inp"}
						placeholder={"search"}
						onChange={( e ) => suggest( e, "search" ) }
						value={ state.selected[ "search" ].query }
					>{}</input>

					<div className={"tech-units-list" + (state.suggested.search.length ? " border-2px-white":  " border-unset" )}>
						{
							state.suggested.search.map(( item: TechnologyItem ) => {
								return (
									<div key={ item.value }>
										<div
											className={
												"tech-icon" + (props.icon ?
													(typeof props.icon == "string" ? (" " + props.icon + (item.icon ? (" " + item.icon) : "")) : "")
													:
													" hidden")
											}
										style={{
											backgroundImage: item.icon && props.icon !== "mdi" ? "url( /s/ti/" + item.icon + " )" : "none"
										}}>{}</div>
										<div
											className={"tech-units-val"}
											onClick={( event ) => select( event, "search", {
												value: item.value,
												title: item.title
											}) }
										>{ item.title }</div>
									</div>
								);
							})
						}
					</div>

				</div>

				<div className={"tech-ver" + (props.version ? "" : " hidden")}>
					<input type={"text"}
						   className={"tech-ver-inp"}
						   placeholder={"Version"}
						   value={ state.selected[ "version" ].query }
						   onFocus={( e: React.FocusEvent<HTMLInputElement> ) => suggest( e as wts_ignore_any, "version" ) }
						   onChange={( e: React.ChangeEvent<HTMLInputElement> ) => dispatch([ "query", { type: "version", query: e.target.value } ]) }
						   ref={ versionInput }
					>{}</input>

					<div className={"tech-units-vlist" + (state.suggested.version.length ? " border-2px-white":  " border-unset" )}>
						{
							state.suggested.version
								.filter(( item: TechnologyItem ) =>  !(state.selected[ "version" ].query && item.value.indexOf( state.selected[ "version" ].query ) < 0) )
								.map(( item: TechnologyItem ) => {
									return (
										<div
											className={"tech-units-val"}
											key={ item.value }
											onClick={( event ) => select( event, "version", {
												value: item.value,
												title: item.title
											}) }
										>{ item.title }</div>
									);
								})
						}
					</div>
				</div>
			</div>

			<div className={"tech-add"} onClick={() => {
				dispatch([ "add", {
					type: typeInput.current?.value,
					value: state.selected[ "search" ].query,
					version: versionInput.current?.value,
				}]);
			}}>Add</div>
			<div className={"tech-list"}>
				<div className={"tech-list-title"}></div>
				<table className={"tech-list-table"}>
					<thead>
						<tr>
							<th>type</th>
							<th>value</th>
							<th className={(props.version ? "" : " hidden")}>version</th>
							<th>remove</th>
						</tr>
					</thead>
					<tbody>
					{
						state.list.map(( item: wts_ignore_any ) => {
							return (
								<tr key={ item.value }>
									<td>{ item.type }</td>
									<td>{ item.value }</td>
									<td className={(props.version ? "" : " hidden")}>{ item.version }</td>
									<td>
										<div  className={ "tech-remove" } onClick={() => dispatch([ "remove", item.value ])}>X</div>
									</td>
								</tr>
							);
						})
					}
					</tbody>
				</table>
			</div>
		</div>
	);
};